import { render, staticRenderFns } from "./cardAcademia.vue?vue&type=template&id=e73c8020&scoped=true"
import script from "./cardAcademia.vue?vue&type=script&lang=js"
export * from "./cardAcademia.vue?vue&type=script&lang=js"
import style0 from "./cardAcademia.vue?vue&type=style&index=0&id=e73c8020&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e73c8020",
  null
  
)

export default component.exports